import { For, JSX } from "solid-js";
import { Product } from "~/server/types/search";
import { BrandCardWebstoreTelescope } from "./brand_card_webstore_telescope";

type BrandGridSectionWebstoreTelescopeProps = {
  brands: Product[];
  onBrandClick: (brandKey: string) => void;
  forceDarkTheme?: boolean;
  categoryNameToTitleMap?: Record<string, string>;
  hideCategoryName?: boolean;
};

/**
 * Brand Grid Section for Webstore Telescope
 * Shared component for home and category pages
 * Responsive grid: 3 columns (mobile), 6 columns (desktop)
 */
export function BrandGridSectionWebstoreTelescope(
  props: BrandGridSectionWebstoreTelescopeProps
): JSX.Element {
  return (
    <div class="flex w-full justify-center">
      <div class="grid w-full max-w-[1024px] grid-cols-3 gap-x-3 gap-y-[16px] px-3 sm:px-0 lg:grid-cols-6 lg:gap-x-6">
        <For each={props.brands}>
          {(brand) => (
            <BrandCardWebstoreTelescope
              brandKey={brand.brandKey}
              name={brand.voucherProduct.title}
              logoUrl={brand.voucherProduct.logoUrl}
              iconImageUrl={brand.voucherProduct.iconImageUrl}
              categoryName={brand.category}
              discount={brand.voucherProduct.discountPercentage}
              onClick={() => props.onBrandClick(brand.brandKey)}
              forceDarkTheme={props.forceDarkTheme}
              cardBackgroundColor={brand.voucherProduct.cardBackgroundColor}
              showHubbleCoinReward={
                brand.voucherProduct.rewardType === "POSTPAID"
              }
              categoryNameToTitleMap={props.categoryNameToTitleMap}
              hideCategoryName={props.hideCategoryName}
            />
          )}
        </For>
      </div>
    </div>
  );
}
